import { availableQuestionVariables } from '../../ModalInstantSurveyQuestion/utilities/constants';

export const DEFAULT_TITLE = 'Numerator Question Library';
export const SCREENER_BLANK_VALUE = '(blank)';
export const SCREENER_HIERARCHY_VARIABLES = ['banner', 'category', 'brand'];
export const SCREENER_URL_VARIABLE_PROMPT_KEY = 'url_variable';
export const SCREENER_PROMPT_TOKEN_REGEX = /{{\s*([a-zA-Z0-9_]+)\s*}}/g;

const toTitleCase = (value: string) =>
  value.replace(/_/g, ' ').replace(/\b\w/g, (character) => character.toUpperCase());

export const SCREENER_HIERARCHY_OPTIONS = SCREENER_HIERARCHY_VARIABLES.filter((variable) =>
  availableQuestionVariables.includes(variable)
).map((variable) => ({
  label: toTitleCase(variable),
  value: variable,
}));
